import RoutingActions from '../../actions/RoutingActions';
import GuestListActions from '../../actions/GuestListActions';
import NotificationActions from '../../actions/NotificationActions';
import PopupActions from '../../actions/PopupActions';
import GuestListStore from '../../stores/GuestListStore';
import UserStore from '../../stores/UserStore';
import AjaxPromises from '../../utils/AjaxPromises';
import { endPoints as GuestListEndPoints } from '../../constants/GuestListConstants';
import KeyupBarcodeScanner from '../scanner/KeyUpBarcodeScanner.react';
import BarcodeScanner from '../scanner/BarcodeScanner.react';
import Transaction from '../profile/view/Transaction.react';
import * as _ from 'lodash';

class GLHeader extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            query: '',
            driverLicense: '',
            createNewProfile: '',
        };

        this.search = _.debounce(this.search.bind(this), 500);
        this.onScan = this.onScan.bind(this);
    }

    componentDidMount() {}

    componentWillUnmount() {}

    onScan(barcode) {
        var self = this;
        var guestList = this.props.guestList;

        if (!UserStore.getState().selectedLocation) {
            return;
        }

        if (barcode.length === 0) {
            return;
        }

        if (this.props.page !== 'quick-scan') {
            GuestListActions.scan(barcode);
        } else {
            AjaxPromises.POST(
                GuestListEndPoints.VALIDATE_PATIENT_ID,
                UserStore.getApiData({
                    id: barcode,
                })
            ).then((res) => {
                self.setState({ driverLicense: '' }, () => {
                    if (res.Result) {
                        var checkedIn = guestList.filter((x) => {
                            if (x.Guest_id === res.Data.PatientId) {
                                return x.MJStateIDNo;
                            }
                        });
                        if (!res.Data.IsValid) {
                            NotificationActions.error('Invalid Scan');
                        } else if (res.Data.IsPatientBanned) {
                            NotificationActions.error('Customer status is Banned');
                        } else if (res.Data.IsMMJLicenseValid) {
                            if (checkedIn.length > 0) {
                                NotificationActions.alert('User is already checked in');
                            } else {
                                NotificationActions.success('User checked in successfully');
                                GuestListActions.loadGuestList(false);
                            }
                        } else if (!res.Data.IsMMJLicenseValid) {
                            if (res.Data.PatientExists) {
                                NotificationActions.alert('User MMJ License is not valid, loading profile.');

                                PopupActions.viewProfile({
                                    Guest_id: res.Data.PatientId,
                                    MJStateIDNo: res.Data.MMJLicenseId,
                                });
                            } else {
                                self.props.newProfile({ MJStateIDNo: barcode[0] === '@' ? '' : barcode });
                            }
                        }
                    } else {
                        NotificationActions.error('Error validating patient ID');
                    }
                });
            });
        }
    }

    search() {
        var self = this;
        var query = this.state.query;

        if (query.length === 0) {
            return;
        }

        this.setState({}, () => {
            GuestListActions.search(query);
            self.props.onSearch();
        });
    }

    render() {
        var page = this.props.page;
        var guestId = this.props.guestId;
        var selected = { PosId: this.props.transactionId };

        var label = page !== 'quick-scan' ? 'Search' : 'Scan';
        var search = page !== 'quick-scan' ? this.search : () => this.onScan(this.state.driverLicense);

        return (
            <div className='gl-header'>
                <div className='gl-header__search'>
                    <input
                        type='text'
                        id='gl-header-search'
                        value={this.state.query}
                        onChange={(e) => {
                            this.setState({ query: e.target.value });
                        }}
                        onKeyDown={(e) => {
                            if (e.keyCode == 13) {
                                this.search();
                            }
                        }}
                        placeholder={page !== 'quick-scan' ? 'Search for guest to check in...' : 'Scan ID Card'}
                    />

                    <div className='gl-header__search--go' onClick={search}>
                        {label}
                    </div>
                </div>

                {page === 'quick-scan' && (
                    <textarea
                        id='QuickScanTextArea'
                        value={this.state.driverLicense}
                        onChange={(e) => {
                            this.setState({ driverLicense: e.target.value });
                        }}
                        className='gl-header__test'
                        placeholder="Scan Driver's License or State ID"
                    />
                )}
                {page === 'quick-scan' || UserStore.getState().selectedLocation.UseKeyupBarcodeScanner ? (
                    <KeyupBarcodeScanner stopPropagation onScan={this.onScan} />
                ) : (
                    <BarcodeScanner onScan={this.onScan} />
                )}

                {page === 'scanTransaction' && (
                    <Transaction
                        guest={guestId}
                        selected={selected}
                        onClose={() => {
                            GuestListStore.setPage('list');
                        }}
                    />
                )}
            </div>
        );
    }
}

export default GLHeader;



// WEBPACK FOOTER //
// ./ui_src/app/components/guest-list/GLHeader.react.jsx